<template>
    <div>
        <div v-if="!historico">
            <div
                class="row col-12 pb-3 px-0 m-0 d-flex justify-content-between"
            >
                <h4 class="font-weight-bold">Saúde</h4>
                <a
                    class="font-weight-light font-italic"
                    role="button"
                    @click="historico = true"
                >
                    <i class="mdi mdi-history"></i>Histórico
                </a>
            </div>
            <div class="row">
                <form-input
                    v-model="documento.cartao_sus"
                    v-mask="'###.####.####.####'"
                    grid="6"
                    label="Cartão do SUS"
                />
                <form-input
                    grid="6"
                    v-model="saude.cns"
                    label="Cadastro nacional de Saúde(CNS)"
                />
                <form-select
                    grid="4"
                    mt="3"
                    v-model="saude.deficiencia"
                    :itens="$root.arrays.perguntas"
                    label="Tem deficiência?"
                />
                <form-calendar
                    grid="8"
                    v-model="data_def"
                    label="Data de início da deficiência"
                    :disabled="saude.deficiencia == 2 ? true : false"
                    :max-date="dataNow"
                />
                <div class="col-md-6 col-sm-12">
                    <label class="font-weight-bold"
                        >Qual é o tipo de deficiência?</label
                    >
                    <form-toggle
                        mt="1"
                        class="px-0"
                        v-model="saude.def_cegueira"
                        label="Cegueira"
                    />
                    <form-toggle
                        mt="1"
                        class="px-0"
                        v-model="saude.def_baixa_visao"
                        label="Baixa Visão"
                    />
                    <form-toggle
                        mt="1"
                        class="px-0"
                        v-model="saude.def_surdez_servera"
                        label="Surdez severa/profunda"
                    />
                    <form-toggle
                        mt="1"
                        class="px-0"
                        v-model="saude.def_surdez_leve"
                        label="Surdez leve/moderada"
                    />
                    <form-toggle
                        mt="1"
                        class="px-0"
                        v-model="saude.def_fisica"
                        label="Deficiência física"
                    />
                    <form-toggle
                        mt="1"
                        class="px-0"
                        v-model="saude.def_mental_intelectual"
                        label="Deficiência mental ou intelectual"
                    />
                    <form-toggle
                        mt="1"
                        class="px-0"
                        v-model="saude.def_sindrome_down"
                        label="Síndrome de Down"
                    />
                    <form-toggle
                        mt="1"
                        class="px-0"
                        v-model="saude.def_transtorno_doenca_mental"
                        label="Transtorno/doença mental"
                    />
                </div>
                <div class="col-md-6 col-sm-12">
                    <label class="font-weight-bold">
                        Em função dessa deficiência, recebe cuidados permanentes
                        de terceiros?
                    </label>
                    <form-toggle
                        mt="1"
                        class="px-0"
                        v-model="saude.ajuda_nao_recebida"
                        label="Não"
                    />
                    <form-toggle
                        mt="1"
                        class="px-0"
                        v-model="saude.ajuda_familia"
                        label="Sim, de alguém da família"
                    />
                    <form-toggle
                        mt="1"
                        class="px-0"
                        v-model="saude.ajuda_especializada"
                        label="Sim, de cuidador especializado"
                    />
                    <form-toggle
                        mt="1"
                        class="px-0"
                        v-model="saude.ajuda_vizinhos"
                        label="Sim, de vizinho"
                    />
                    <form-toggle
                        mt="1"
                        class="px-0"
                        v-model="saude.ajuda_instituicao"
                        label="Sim, de instituição da rede socioassistencial"
                    />
                    <form-toggle
                        mt="1"
                        class="px-0"
                        v-model="saude.ajuda_outra_forma"
                        label="Sim, de outra forma"
                    />
                </div>
                <form-input
                    mt="3"
                    v-model="saude.responsavel_nome"
                    label="Nome do responsável pelos cuidados"
                />
                <form-select
                    grid="6"
                    v-model="saude.uso_remedio_controlado"
                    :itens="$root.arrays.perguntas"
                    label="Faz uso de remédios controlados para transtornos mentais?"
                />
                <form-input
                    grid="6"
                    v-model="saude.remedio_controlado_nome"
                    label="Nome do Medicamento"
                />
                <form-select
                    grid="6"
                    v-model="saude.uso_abusivo_alcool"
                    :itens="$root.arrays.perguntas"
                    label="Faz uso abusivo de álcool?"
                />
                <form-select
                    grid="6"
                    v-model="saude.uso_abusivo_drogas"
                    :itens="$root.arrays.perguntas"
                    label="Faz uso abusivo de crack ou outras drogas (cocaína, maconha etc)?"
                />
                <form-input
                    grid="6"
                    v-model="saude.droga_nome"
                    label="Nome da substância/droga?"
                />
                <form-input
                    type="number"
                    grid="3"
                    v-model="saude.droga_tempo_uso"
                    label="Tempo de uso?"
                />
                <form-select
                    grid="3"
                    label="Período de uso?"
                    v-model="saude.droga_periodo_uso"
                    :itens="$root.arrays.periodo_enum"
                />
                <form-select
                    grid="6"
                    label="Possui questões de saúde?"
                    v-model="saude.portador_doenca"
                    :itens="$root.arrays.perguntas"
                />
                <!-- <form-input
          grid="6"
          v-model="saude.doenca_nome"
          label="Nome da doença? Buscar Doença CID*"
        /> -->
                <!-- <form-select
                    grid="6"
                    v-model="saude.doenca_nome"
                    :itens="$root.cid"
                    label="Nome da doença - Listagem CID*"
                /> -->
                <form-Select-autocomplete
                    :grid="6"
                    v-model="saude.doenca_nome"
                    label="Nome da doença - Listagem CID"
                    :items="[]"
                    @selected="saude.doenca_nome = $event.name"
                    :required="true"
                    :isAsync="true"
                />
                <h6 class="col-12 font-weight-bold mt-3">
                    Estabelecimento de Saúde em que o usuário é atendido quando necessita
                </h6>
                <form-input
                    grid="6"
                    v-model="saude.estabelecimento_saude_nome"
                    label="Nome do estabelecimento"
                />
                <form-input
                    grid="6"
                    v-model="saude.estabelecimento_saude_codigo"
                    label="Código do estabelecimento"
                />
                <form-select
                    grid="6"
                    label="Faz algum tratamento de saúde?"
                    v-model="saude.faz_tratamento_saude"
                    :itens="$root.arrays.pergunta"
                />
                <form-input
                    grid="6"
                    v-if="saude.faz_tratamento_saude == 1"
                    v-model="saude.qual_tratamento_saude"
                    label="Qual tratamento de saúde?"
                />
                <form-select
                    grid="6"
                    label="Já foi internado para tratamento/desintoxicação?"
                    v-model="saude.internado_tratamento"
                    :itens="$root.arrays.pergunta"
                />
                <form-input
                    grid="6"
                    v-if="saude.internado_tratamento == 1"
                    v-model="saude.periodo_tratamento_saude"
                    label="Período internado para tratamento/desintoxicação"
                />
                <form-input
                    grid="6"
                    v-if="saude.internado_tratamento == 1"
                    v-model="saude.local_tratamento_saude"
                    label="Local internado para tratamento/desintoxicação"
                />
                <form-select
                    grid="6"
                    label="Vida sexual ativa?"
                    v-model="saude.vida_sexual"
                    :disabled="disabledFromOsasco()"
                    :itens="$root.arrays.pergunta"
                />
                <form-input
                    grid="6"
                    v-if="saude.vida_sexual == 1"
                    v-model="saude.tempo_vida_sexual"
                    label="Quanto tempo da vida sexual ativa?"
                />
                <form-select
                    grid="6"
                    label="Faz uso de preservativo ou outro método contraceptivo?"
                    v-model="saude.uso_preservativo"
                    :itens="$root.arrays.pergunta"
                    :disabled="disabledFromOsasco()"
                />
                <form-select
                    grid="6"
                    label="Tem parceiro (a) fixo?"
                    v-model="saude.parceiro_fixo"
                    :itens="$root.arrays.pergunta"
                    :disabled="disabledFromOsasco()"
                />
            </div>

            <div class="row pt-4 px-2 d-flex justify-content-end">
                <form-toggle
                    grid="9"
                    class="d-flex justify-content-end"
                    mt="1"
                    v-model="item.nova_condicao_saude"
                    label="Cadastrar uma nova condição de saúde"
                />
                <button @click="submit" class="btn btn-success btn-submit">
                    <i class="mdi mdi-content-save"></i>
                    Salvar
                </button>
            </div>
        </div>
        <div v-else>
            <Historico
                :id="item.id"
                tipo="saude"
                title="Saúde"
                @voltar="historico = false"
            />
        </div>
    </div>
</template>
<script>
import Historico from "../Historico/Saude";
export default {
    components: { Historico },
    props: ["item"],
    data() {
        return {
            saude: {},
            documento: {},
            historico: false,
        };
    },
    mounted() {
        this.setValue();
    },
    computed: {
        data_def: {
            get: function () {
                if (this.saude.deficiencia_data_inicio == "1969-12-31") {
                    return (this.saude.deficiencia_data_inicio = null);
                } else {
                    return this.saude.deficiencia_data_inicio;
                    // return moment(this.saude.deficiencia_data_inicio).format(
                    //     "YYYY/MM/DD"
                    // );
                }
            },
            set: function (newValue) {
                return (this.item.saude.deficiencia_data_inicio = newValue);
            },
        },
    },
    watch: {
        "saude.deficiencia": function (value) {
            if (value == 2) {
                this.saude.deficiencia_data_inicio = null;
            }
        },
        item(n, o) {
            this.setValue();
        },
    },
    methods: {
        disabledFromOsasco(){
            //
            if(window.location.hostname == 'osascosp.suasfacil.com.br'){
                return true;
            }else{
                return false;
            }
            
        },
        setValue() {
            if (this.item.saude != null) {
                this.saude = this.item.saude;
            }
            if (this.item.documento != null) {
                this.documento = this.item.documento;
            }
        },
        submit() {
            this.item.saude = this.saude;
            this.item.documento = this.documento;
            this.$emit("submit");
        },
    },
};
</script>
